export function startOfDay(d) {
  const x = new Date(d)
  x.setHours(0, 0, 0, 0)
  return x
}

export function endOfDay(d) {
  const x = startOfDay(d)
  x.setDate(x.getDate() + 1)
  return x
}

export function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
}

export function formatDatePill(d) {
  return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })
}

export function formatGmtLabel() {
  const off = -new Date().getTimezoneOffset()
  const sign = off >= 0 ? '+' : '-'
  const abs = Math.abs(off)
  const h = Math.floor(abs / 60)
  const m = abs % 60
  return `GMT${sign}${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

/** @param {import('./types').CalendarEvent} event */
export function eventIntersectsDay(event, day) {
  const start = new Date(event.start)
  const end = new Date(event.end)
  const d0 = startOfDay(day)
  const d1 = endOfDay(day)
  return start < d1 && end > d0
}

export function addDays(d, n) {
  const x = new Date(d)
  x.setDate(x.getDate() + n)
  return x
}

export function monthMatrix(viewMonth) {
  const y = viewMonth.getFullYear()
  const m = viewMonth.getMonth()
  const first = new Date(y, m, 1)
  const startPad = first.getDay()
  const cells = []
  const cursor = new Date(y, m, 1 - startPad)
  for (let i = 0; i < 42; i++) {
    cells.push(new Date(cursor))
    cursor.setDate(cursor.getDate() + 1)
  }
  return cells
}
